<template>
  <div>
    <Head :title="orderChange.data.id.toString()"/>


    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/nderrimet">Ndërrimet & Kthimet</Link>
      <span class="text-indigo-400 font-medium">/</span>
      {{ orderChange.data.id }}
    </h1>

    <danger-flash-message :message="`Koment: ${orderChange.data.description}`"></danger-flash-message>

    <div class=" bg-white rounded-md shadow overflow-hidden">
      <div class="flex flex-wrap items-center space-y-4 lg:space-y-0 justify-between -mr-6 p-5">

        <div class="flex flex-wrap mb-4">
          <label class="font-bold">Statusi Aktual: &nbsp;</label>
          <p><span class="mx-0.5 px-2 py-1 rounded-md text-white" :class="statusColor"
          >{{ orderChange.data.status }}</span></p>
        </div>

      </div>
    </div>


    <div class="flex flex-wrap  space-y-4 lg:flex-nowrap lg:space-x-4 lg:space-y-0 mb-8 mt-5">
      <div class=" bg-white rounded-md shadow overflow-hidden w-full lg:w-1/2">

        <div class="flex flex-wrap lg:flex-nowrap mb-6 items-center justify-between">

          <div class="flex flex-wrap items-end space-y-4 lg:space-y-0 -mb-8 p-8">
            <!--            <Link  v-if="!order.data.is_change"  class="mr-1" :href="`${order.data.id}/edit`" ><icon name="edit" class="mr-2 w-4 h-4"></icon></Link>-->
<!--            <dropdown class="mr-2 w-4 h-4" placement="bottom-end">-->
<!--              <template #default>-->
<!--                <icon name="print" class="mr-2 w-4 h-4"></icon>-->
<!--              </template>-->
<!--              <template #dropdown>-->
<!--                <div class="mt-2 py-2 text-sm bg-white rounded shadow-xl">-->
<!--                  <a type="button" :href="`${orderChange.data.id}/print`" class="block px-6 py-2 hover:text-white hover:bg-indigo-500" target="_blank">Printo PDF</a>-->
<!--                </div>-->
<!--              </template>-->
<!--            </dropdown>-->
          </div>


        </div>
        <hr>


        <div class="flex flex-wrap -mb-8 p-8">
          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="font-bold">Dërgesa e vjetër</label>
            <p>{{orderChange.data.old_order_id}}</p>
          </div>

          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="font-bold">Dërgesa e re</label>
            <p>{{ orderChange.data.new_order_id }}</p>
          </div>

          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="font-bold">Pika marrëse</label>
            <p>{{ orderChange.data.location }}</p>
          </div>

          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="font-bold">Biznesi</label>
            <p>{{ orderChange.data.business }}</p>
          </div>


          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="font-bold">Produkti për kthim</label>
            <p>{{ orderChange.data.old_product }}</p>
          </div>

          <div class="pb-8 pr-6 w-full lg:w-2/4">
            <label class="font-bold">Informata shtesë</label>
            <p>{{ orderChange.data.description }}</p>
          </div>

          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="font-bold">Data e regjistrimit</label>
            <p>{{orderChange.data.hr_created_at}}</p>
          </div>
        </div>
      </div>

      <div class=" bg-white rounded-md shadow overflow-hidden p-5  w-full lg:w-1/2">
        <h1 class="mb-3 text-xl font-bold">Gjurmimi i ndërrimit</h1>

        <div class="flex flex-wrap -mb-8 p-8">
          <order-change-status-timeline :items="orderChangeStatusLogs.data"></order-change-status-timeline>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import {Head, Link, usePage} from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TextareaInput from '@/Shared/TextareaInput'
import {computed} from 'vue'
import SearchFilter from '@/Shared/SearchFilter'
import Icon from '@/Shared/Icon'
import TrashedMessage from '@/Shared/TrashedMessage'
import FileOutput from '@/Shared/FileOutput'
import Modal from '@/Shared/Modal'
import FileInput from '@/Shared/FileInput'
import OrderChangeStatusTimeline from '@/Shared/OrderChangeStatusTimeline'
import DangerFlashMessage from '@/Shared/DangerFlashMessage'
import Dropdown from '@/Shared/Dropdown'

export default {
  components: {
    OrderChangeStatusTimeline,
    Icon,
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TextareaInput,
    SearchFilter,
    TrashedMessage,
    FileOutput,
    Modal,
    FileInput,
    DangerFlashMessage,
    Dropdown
  },
  layout: Layout,
  props: {
    orderChange: Object,
    orderChangeStatusLogs: Object,
  },
  data() {
    return {
      statusSuccess: this.orderChange.data.status_id === 5,
      statusCancellation: this.orderChange.data.status_id === 6,
    }
  },

  setup() {
    const user = computed(() => usePage().props.value.auth.user)
    return {user}
  },
  computed: {
    statusColor() {
      let color = 'bg-indigo-500'
      if (this.orderChange.data.status_id === 1)
        color = 'bg-yellow-500'

      if (this.orderChange.data.status_id === 3)
        color = 'bg-orange-500'

      if (this.orderChange.data.status_id === 4)
        color = 'bg-indigo-900'

      if (this.orderChange.data.status_id === 5)
        color = 'bg-green-500'

      if (this.orderChange.data.status_id === 6)
        color = 'bg-red-500'


      return color
    },
  },
}
</script>

<style>
</style>
